import React, { useRef } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import "./VaccinationDateField.css";

const wrapperStyle = {
  display: "flex",
  alignItems: "center",
  border: "1px solid #125386",
  borderRadius: "10px",
  padding: "0 12px",
  gap: "6px",
  width: "100%",
  backgroundColor: "#FDFDFD",
  height: "48px",
  boxSizing: "border-box",
};

const inputStyle = {
  flex: 1,
  border: "none",
  outline: "none",
  background: "transparent",
  color: "#1c2c4c",
  fontWeight: 500,
  fontSize: "12px",
  height: "100%",
  minWidth: 0,
  padding: 0,
  fontFamily: "inherit",
  cursor: "text",
};

/**
 * Native date input — same typing UX as RegisterPatient DOB (dd-mm-yyyy segments).
 * Value is always YYYY-MM-DD for save/API compatibility.
 */
const VaccinationDateField = ({
  id = "dateOfAdministration",
  value = "",
  onChange,
}) => {
  const inputRef = useRef(null);

  const openPicker = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const input = inputRef.current;
    if (!input) return;
    if (typeof input.showPicker === "function") {
      input.showPicker();
    } else {
      input.focus();
      input.click();
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="custom-date-input vaccination-date-field" style={wrapperStyle}>
        <FaCalendarAlt
          style={{
            fontSize: "14px",
            color: "#0E3F66",
            flexShrink: 0,
            cursor: "pointer",
          }}
          onMouseDown={openPicker}
        />
        <input
          ref={inputRef}
          id={id}
          type="date"
          className="vaccination-date-native-input"
          value={value || ""}
          onChange={(e) => onChange(e.target.value || "")}
          style={inputStyle}
        />
        <IoMdArrowDropdown
          style={{
            fontSize: "20px",
            color: "#125386",
            flexShrink: 0,
            cursor: "pointer",
          }}
          onMouseDown={openPicker}
        />
      </div>
    </div>
  );
};

export default VaccinationDateField;
